import { HttpClient } from '@angular/common/http';
import { inject, Injectable } from '@angular/core';
import { AuthService } from '@core/auth/auth.service';
import { environment } from '@environments/environments';
import { BehaviorSubject, catchError, EMPTY, from, mergeMap, take } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class FirebaseMessagesService {
  protected httpClient = inject(HttpClient);
  private authService = inject(AuthService);

  currentMessage = new BehaviorSubject(null)
  private baseUrl = environment.apiUrl;

  requestPermission() {
    if (typeof Notification === 'undefined') return;
    from(Notification.requestPermission()).pipe(take(1)).subscribe((permission) => {
      if (permission === 'granted') this.requestToken();
    })
  }

  requestToken() {
    from(this.getDeviceToken()).pipe(
      take(1),
      mergeMap((token) => {
        if (token && this.authService.accessToken) {
          return this.httpClient.post(`${this.baseUrl}api/user-devices`, {userId: this.authService?.userProfile?.userProfile?.userId, deviceId: token}).pipe(
            take(1),
            catchError(() => EMPTY)
          );
        }
        return EMPTY;
      }),
      catchError((error: unknown) => {
        console.warn('Unable to register this device for push notifications.', error);
        return EMPTY;
      })
    ).subscribe();
  }

  /**
   * Gets the FCM registration token for this browser, or null when the browser does not support
   * web push (e.g. Safari outside an installed PWA). The messaging SDK is loaded on demand.
   */
  private async getDeviceToken(): Promise<string | null> {
    const [{ getApp, getApps, initializeApp }, { getMessaging, getToken, isSupported }] = await Promise.all([import('firebase/app'), import('firebase/messaging')]);
    if (!(await isSupported())) return null;
    const app = getApps().length ? getApp() : initializeApp(environment.firebaseConfig);
    return getToken(getMessaging(app));
  }

}
